import compact from 'lodash/compact'
import { Maybe } from 'types/graphqlTypes'
import { titleCase } from 'utils/titleCase'

/**
 * Returns formatted label with fallbacks
 * @example getOptionLabel('8117 facility', 'GOSHEN', 'NY') // '8117 Facility, Goshen, NY'
 */
export const getOptionLabel = (
  name: Maybe<string>,
  city: Maybe<string>,
  stateCode: Maybe<string>,
  address?: Maybe<string>
): string => {
  const cityFormatted = titleCase(city ?? '')
  const stateFormatted = stateCode ?? ''
  const location = compact([address, cityFormatted, stateFormatted]).join(', ')
  return [name, location].join(' - ')
}
